// extracted by mini-css-extract-plugin
module.exports = {"Input":"styles_Input__tyvYO","input":"styles_input__hZgFw","error":"styles_error__1iaY5","errorList":"styles_errorList__7RWkK","birthDate":"styles_birthDate__7PFPh"};